import { registerMiddleware } from "./libs/react-router";
import { SessionUser } from "./libs/localstorage";
import { filterPermission } from "./utils/permission";
import { Route, isPublicRoute } from "./commons/route";

const mappingRoutePermissions: Array<{
  path: string;
  permissions?: string[];
}> = [{ path: Route.Dashboard }];

registerMiddleware({
  matcher: "^/$",
  handler: () => {
    const session = SessionUser.get();
    if (session) {
      return { redirect: Route.Dashboard };
    }
    return { redirect: Route.Login };
  },
});

registerMiddleware({
  matcher: ".*",
  handler: (request) => {
    const url = new URL(request.url);
    const pathname = url.pathname;
    const session = SessionUser.get();

    const isPublic = isPublicRoute(pathname);
    const shouldRedirectToDashboard = isPublicRoute(pathname, { excludeNoRedirect: true });

    if (!isPublic && !session) {
      const redirectSearch = pathname !== Route.Dashboard ? `?redirect=${encodeURIComponent(pathname)}` : "";
      const redirectTo = `${Route.Login}${redirectSearch}`;
      return { redirect: redirectTo };
    }

    if (shouldRedirectToDashboard && session) {
      return { redirect: Route.Dashboard };
    }

    // if (session) {
    //   const userPermissions: string[] =
    //     session?.user?.roles
    //       ?.map((role) => role.permissions.map((perm: { name: string }) => perm.name))
    //       ?.flat() || [];

    //   const rulesForPath = mappingRoutePermissions.filter((rule) => rule.path === pathname);
    //   const allowedRules = filterPermission(rulesForPath, (rule) => {
    //     if (!rule.permissions || rule.permissions.length === 0) return true;
    //     return rule.permissions.some((perm) => userPermissions.includes(perm));
    //   });

    //   if (rulesForPath.length > 0 && allowedRules.length === 0) {
    //     return { redirect: Route.Dashboard };
    //   }
    // }

    return;
  },
});
